module.exports = __webpack_public_path__ + "media/images/yellow_circle_big_shadow-7d8a34d86314fb48e736fb8cae41c217.svg";